import { render, staticRenderFns } from "./uploadImg.vue?vue&type=template&id=336b0d3c&scoped=true"
import script from "./uploadImg.vue?vue&type=script&lang=js"
export * from "./uploadImg.vue?vue&type=script&lang=js"
import style0 from "./uploadImg.vue?vue&type=style&index=0&id=336b0d3c&prod&lang=less&scoped=true"
import style1 from "./uploadImg.vue?vue&type=style&index=1&id=336b0d3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336b0d3c",
  null
  
)

export default component.exports